/*
 * Tooltip jQuery plugin
 * by Jordan Cole / Opal Labs, Inc.
 * http://workwithopal.com
 *
 * Given `$("#example").tooltip();` the plugin expects `#example` to have a
 * `title` attribute.
 *
 * Code inspired by Jon Cazier's 'Better Tooltip' plugin:
 * http://net.tutsplus.com/tutorials/javascript-ajax/build-a-better-tooltip-with-jquery-awesomeness/
 *
 */

;(function ($) {
  var PLUGIN_NAME = 'tooltip',
    $tipProto = $(
      "<div class='tooltip'><div class='tooltip-text'></div><div class='tooltip-arrow'></div></div>"
    )

  function Plugin(elem, options) {
    var $trigger = $(elem),
      $eventTrigger,
      $tip = $tipProto.clone(),
      defaults = {
        after_initialize: function () {},
        always_center: false,
        before_show_condition: function () {
          return true
        },
        before_show: function () {},
        hide_on_click: false,
        ignore_disabled: false,
        speed: 125,
        delay: 50,
        with_html: false,
        adjust_to_viewport: true,
      },
      settings = $.extend({}, defaults, options),
      $arrow = $tip.find('.tooltip-arrow'),
      text = $trigger.prop('title'),
      is_visible = false,
      tip_id,
      arrow_height = 0

    $trigger.prop('title', '')

    function _setEventTrigger() {
      var altTrigger = $trigger.data('altTrigger')
      var $altTrigger = $trigger.find(altTrigger)

      if ($altTrigger[0]) {
        $eventTrigger = $altTrigger
      } else {
        $eventTrigger = $trigger
      }
    }

    function _update_content(e, content) {
      $tip.children('.tooltip-text').html(content)
    }
    function _set_content($tip, content) {
      $tip.children('.tooltip-text').html(content)
    }

    // Tooltip position depends on its width:
    //   - if the tooltip's width is 100px or less, the entire thing is
    //     centered above $trigger
    //   - otherwise, the arrow is centered above $trigger and positioned 23px
    //     from the right of the tooltip
    //
    // In either case, if the tooltip is outside the left or right of the
    // viewport it will adjust itself to be inside.
    function positionTip($trigger, $tip) {
      var is_down = $trigger.hasClass('down'),
        adjusted_x = 0,
        trigger_h = $trigger.outerHeight(),
        trigger_w = $trigger.outerWidth(),
        tip_h = $tip.outerHeight(),
        tip_w = $tip.outerWidth(),
        win_w = $(window).width(),
        arrow_x = tip_w / 2,
        x = $trigger.offset().left - (tip_w - trigger_w) / 2,
        y = $trigger.offset().top

      if (is_down) {
        y += trigger_h + (arrow_height + 3)
      } else {
        y -= tip_h + (arrow_height + 3)
      }

      // opallabs/opal#746
      if (settings.adjust_to_viewport) {
        if (x < 3) {
          adjusted_x = 3
        } else if (x + tip_w + 3 > win_w) {
          adjusted_x = win_w - tip_w - 3
        }
        if (adjusted_x !== 0) {
          arrow_x += x - adjusted_x
          x = adjusted_x
        }
      }

      $tip.toggleClass('is-pointing-down', is_down).css({ top: y, left: x })
      $arrow.css({ left: arrow_x })
    }

    function showTip($trigger, $tip, text) {
      var enabled = settings.ignore_disabled || !$trigger.hasClass('disabled')

      if (
        enabled &&
        !is_visible &&
        settings.before_show_condition({ $trigger: $trigger, $tip: $tip })
      ) {
        settings.before_show()
        // @opallabs/Opal#413
        $('.tip').not($tip).hide()
        is_visible = true
        if (!settings.with_html) {
          _set_content($tip, text)
        }
        positionTip($trigger, $tip)
        $tip.fadeIn(settings.speed)
      }
    }

    // current timestamp + random number
    function generateTipId() {
      return (
        'tip_' + new Date().getTime() + '-' + Math.floor(Math.random() * 1000)
      )
    }

    function setTriggerTitle() {
      if (text != $trigger.prop('title') && $trigger.prop('title').length > 0) {
        text = $trigger.prop('title')

        // If `$trigger` has a class like `tip-foo`, `$tip` gets a class of `foo`.
        $trigger.prop('title', '')
        $trigger.data('title', text)
      }
    }

    function initialize(first_load) {
      first_load = typeof first_load !== 'undefined' ? first_load : true
      $trigger.off('.tooltip_init')

      _setEventTrigger()

      if (settings.with_html || (undefined !== text && '' !== text)) {
        setTriggerTitle()

        var tip_classes = $trigger.attr('class').match(/tip-(\S+)/g)

        if (tip_classes) {
          var tip_class_count = tip_classes.length
          for (var i = 0; i < tip_class_count; i++) {
            var class_name = tip_classes[i].split('tip-')[1]
            $tip.addClass(class_name)
          }
        }

        $('body').append($tip)

        // Temporarily show a tooltip so `$arrow` has dimensions.
        $tip.show()
        arrow_height = $arrow.outerHeight()
        $tip.hide()

        // Set `tip_id` to track which tooltip is associated with `$trigger`.
        tip_id = generateTipId()
        $trigger.attr('data-tip_id', tip_id)
        $tip.attr('id', tip_id)

        // LISTENERS
        function _resize() {
          if ($tip.is(':visible')) {
            positionTip($trigger, $tip)
          }
        }
        $(window)
          .off('.tooltip_' + tip_id)
          .on('resize.tooltip_' + tip_id, _resize)

        function _mouseenter() {
          showTip($trigger, $tip, text)
        }
        function _hide() {
          $tip.hide()
          is_visible = false
        }
        function _mouseleave() {
          $tip.fadeOut(100)
          is_visible = false
        }
        function _mousedown() {
          $tip.hide()
        }
        function _destroy() {
          $(window).off('.tooltip_' + tip_id)
          $tip.remove()
        }
        function _reset(e) {
          _destroy(e)
          text =
            $trigger.prop('title').length > 0
              ? $trigger.prop('title')
              : $trigger.data('title')
          initialize(false)
        }
        $eventTrigger
          .off('.tooltip')
          .lazybind(
            'mouseenter.tooltip',
            _mouseenter,
            settings.delay,
            'mouseleave.tooltip'
          )
          .on('mouseleave.tooltip', _mouseleave)
          .on('mousedown.tooltip', _mousedown)
          .on('destroy.tooltip', _destroy)
          .on('reset.tooltip', _reset)
          .on('update_content.tooltip', _update_content)
        // can't use `true` on `data` attribute because HAML converts
        // `data: { foo: true }` into `data-foo=""`
        if (
          settings.hide_on_click ||
          'hide' === $trigger.data('hide_tooltip_on_click')
        ) {
          $trigger.on('click.tooltip', _hide)
        }
        $trigger.on('hide.tooltip', _mouseleave)
        $tip.on('hide.tooltip', _mouseleave)

        settings.after_initialize($trigger, $tip)

        // User entered `$trigger` to initializate, so show tooltip.
        if (first_load) {
          $eventTrigger.trigger('mouseenter.tooltip')
        }
      }
    }

    // Lazy initialization
    $trigger.off('.tooltip_init').on('mouseenter.tooltip_init', initialize)
  }

  $.fn[PLUGIN_NAME] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + PLUGIN_NAME)) {
        $.data(this, 'plugin_' + PLUGIN_NAME, new Plugin(this, options))
      }
    })
  }
})(jQuery)
